import { z } from 'zod'

const DrivingSummarySchema = z.object({
  total_earnings: z.number(),
  completed_gigs: z.number(),
  miles_driven: z.number(),
})

export const DrivingSummaryResponseSchema = z.object({
  summary: DrivingSummarySchema,
})

type DrivingSummaryResponse = z.infer<typeof DrivingSummaryResponseSchema>

// TODO: Change fields from snake_case to camelCase (will involve updating deserialization function and changing all references to these fields)
export type DrivingSummary = {
  total_earnings: number
  completed_gigs: number
  miles_driven: number
}

export type DrivingSummaryData = {
  summary: DrivingSummary
}

export function deserializeDrivingSummaryData(data: unknown): DrivingSummaryData {
  const validatedData = data as DrivingSummaryResponse
  return {
    summary: validatedData.summary,
  }
}
